import type { ReactNode } from 'react';

import { Card } from '@/components/ui/Card';

export function MetricCard({ label, value, icon }: { label: string; value: string; icon: ReactNode }) {
  return (
    <Card className="rounded-3xl p-4">
      <div className="mb-2 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
        {icon}
        <span>{label}</span>
      </div>
      <div className="text-sm font-semibold text-slate-950 dark:text-slate-50">{value}</div>
    </Card>
  );
}
